// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__CP9IH","buttons":"RemoveExpirationActionButtons_buttons__1jiEG"};